import {
    CALCULATE_FONT_USAGE,
    GET_FONT_LIST_SUCCESS,
    GET_FONT_LIST_FAILED,
    GET_FONT_LIST_REQUESTED,
    SET_AVAILABLE_FONTS,
    GET_FONT_LIST_NOT_FOUND,
    REFRESH_SELECTED_THEME_FILE
} from '../constants/ActionTypes';
import { get, set, merge, uniq } from 'lodash';
import { CATEGORIES, FileService } from '../services/fileUpload/uploadFile';
import { ThemeService, checkIfThemeExists, saveThemeCodeToFrontman } from '../services/ThemeService';

const setAvailableFonts = fonts => ({ type: SET_AVAILABLE_FONTS, fonts });
const isFileNotFound = error => get(error, 'response.status') === 404;

export const loadFonts = options => dispatch => {
    const { chainId, hotelId, level } = options;
    dispatch({ type: GET_FONT_LIST_REQUESTED });
    const availableFonts = {};
    return FileService.getList(chainId, hotelId, level, CATEGORIES.FONT).then(
        assetList => {
            dispatch({ type: GET_FONT_LIST_SUCCESS });

            assetList.forEach(asset => {
                const metadata = JSON.parse(get(asset, ['metadata', 'Value'], '{}'));
                if (get(availableFonts, [metadata.fontfamily])) {
                    merge(availableFonts[metadata.fontfamily], {
                        files: {
                            [`${metadata.fontstyle}:${metadata.fontweight}`]: uniq([
                                ...(availableFonts[metadata.fontfamily].files[
                                    `${metadata.fontstyle}:${metadata.fontweight}`
                                ] || []),
                                FileService.assetUrl(
                                    asset.chainid,
                                    asset.hotelid,
                                    null,
                                    level,
                                    asset.filename,
                                    true,
                                    CATEGORIES.FONT
                                )
                            ])
                        },
                        weights: uniq([...(availableFonts[metadata.fontfamily].weights || []), metadata.fontweight]),
                        styles: uniq([...(availableFonts[metadata.fontfamily].styles || []), metadata.fontstyle])
                    });
                } else {
                    set(availableFonts, [metadata.fontfamily], {
                        files: {
                            [`${metadata.fontstyle}:${metadata.fontweight}`]: [
                                FileService.assetUrl(
                                    asset.chainid,
                                    asset.hotelid,
                                    null,
                                    level,
                                    asset.filename,
                                    true,
                                    CATEGORIES.FONT
                                )
                            ]
                        },
                        weights: [metadata.fontweight],
                        styles: [metadata.fontstyle]
                    });
                }
            });

            dispatch(setAvailableFonts(availableFonts));
            return dispatch({
                type: CALCULATE_FONT_USAGE,
                changed: false
            });
        },
        error => {
            isFileNotFound(error)
                ? dispatch({ type: GET_FONT_LIST_NOT_FOUND })
                : dispatch({ type: GET_FONT_LIST_FAILED, options });

            dispatch(setAvailableFonts({}));
        }
    );
};

export const saveThemeFile = (selected, params) => dispatch => {
    const {
        themeToSave,
        code: themeCode,
        level,
        chain: { Id: chainId },
        selectedHotel: { id: hotelId }
    } = selected;
    const isThemeSaveAsNew = !themeCode;
    const combinedThemeFileObj = {
        Data: themeToSave,
        MetaData: {
            Comment: params.comments,
            Name: params.name
        }
    };
    const themePromise = isThemeSaveAsNew
        ? ThemeService.new(chainId, hotelId, params.code, combinedThemeFileObj, level)
        : ThemeService.update(chainId, hotelId, themeCode, combinedThemeFileObj, level);

    return themePromise.then(response => {
        if (response.data.Result.ResultCode === 'SUCCESS') {
            if (isThemeSaveAsNew) {
                saveThemeCodeToFrontman({
                    code: params.code,
                    chainId,
                    hotelId,
                    saveLevel: level,
                    name: params.name
                });
            } else {
                checkIfThemeExists({ chainId, hotelId, shellCode: themeCode }).then(response => {
                    if (!response) {
                        saveThemeCodeToFrontman({
                            code: themeCode,
                            chainId,
                            hotelId,
                            saveLevel: level,
                            name: params.name
                        });
                    }
                });
            }
            return ThemeService.reload(chainId, hotelId, level, isThemeSaveAsNew ? params.code : themeCode, true).then(
                () => {
                    dispatch({ type: REFRESH_SELECTED_THEME_FILE });
                }
            );
        } else {
            return Promise.reject(response.data.Result.ResultCode);
        }
    });
};



// WEBPACK FOOTER //
// ./src/actions/theme.js